<template>
  <div class="comments-intro-header-wrapper" v-if="show">
    <div class="intro-left-section">
      <img :src="require('@/assets/icons/commentIcon.svg')" />
      <div class="intro-msg">
        <h2 class="intro-title">{{ title }}</h2>
      </div>
    </div>
    <div class="intro-right-section">
      <button class="intro-btn-wrapper" @click="handleOpenTutorial()">
        <p class="intro-btn-text">{{ buttonText }}</p>
      </button>
      <button class="close-btn" @click="handleClose()">
        <img :src="require('@/assets/icons/close.svg')" alt="">
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommentsIntroHeader',
  props: {
    title: {
      type: String,
      default: 'Introducing the Comments'
    },
    buttonText: {
      type: String,
      default: 'See how it works'
    }
  },
  data(){
    return {
      show : true,
    }
  },
  methods: {
    handleOpenTutorial() {
      this.$emit('open-tutorial')
    },
    handleClose() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.comments-intro-header-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5em;
  background: white;
  padding: 0.6rem 1.5rem;
  color: var(--secondary-font-color);
  justify-content: space-between;
}

.intro-left-section {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.intro-right-section {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;
}

.intro-btn-wrapper {
  display: flex;
  gap: 0.5em;
  justify-content: center;
  background: #FFC6FB;
  border: 1px solid #FFFFFF33;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  color: var(--primary-font-color);
  font-size: var(--normal-font-size);
  cursor: pointer;
}

.intro-btn-text {
  color: var(--primary-font-color);
  margin: 0;
}

.intro-msg {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: black;
  font-size: 12px;
}

.intro-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}
</style>
